import {
  IsArray,
  IsBoolean,
  IsDefined,
  IsInt, IsNumber,
  IsOptional,
  IsString
} from 'class-validator';
import { Type } from 'class-transformer';

export class GetAllStocksByFiltersForLocationDto {
  @IsDefined()
  @IsString()
  @Type(() => String)
  merchantId: string;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  page: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  limit: number;

  @IsOptional()
  @IsString()
  @Type(() => String)
  search?: string;

  @IsOptional()
  @IsString()
  @Type(() => String)
  stockActiveState?: string;

  @IsOptional()
  @IsString()
  @Type(() => String)
  supplierId?: string;

  @IsOptional()
  @IsString()
  @Type(() => String)
  stockCategoryId?: string;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  excludeStockIds?: number[];
}
